import { getCurrentFramework } from './getCurrentFramework.js';
import { getIsConsentOrPay } from './isConsentOrPay.js';
import { mark } from './lib/mark.js';
import { PRIVACY_MANAGER_AUSTRALIA, PRIVACY_MANAGER_USNAT, PRIVACY_MANAGER_TCFV2, PRIVACY_MANAGER_TCFV2_CONSENT_OR_PAY } from './lib/sourcepointConfig.js';
import { willShowPrivacyMessage as willShowPrivacyMessage$1, init as init$1 } from './sourcepoint.js';
const init = (framework, countryCode, isUserSignedIn, useNonAdvertisedList, pubData) => {
    mark("cmp-init");
    init$1(framework, countryCode, isUserSignedIn, useNonAdvertisedList, pubData);
};
const willShowPrivacyMessage = () => willShowPrivacyMessage$1;
function showPrivacyManager() {
    switch (getCurrentFramework()) {
        case "tcfv2":
            window._sp_?.gdpr?.loadPrivacyManagerModal?.(getIsConsentOrPay() ? PRIVACY_MANAGER_TCFV2_CONSENT_OR_PAY : PRIVACY_MANAGER_TCFV2);
            break;
        case "usnat":
            window._sp_?.usnat?.loadPrivacyManagerModal?.(PRIVACY_MANAGER_USNAT);
            break;
        case "aus":
            window._sp_?.ccpa?.loadPrivacyManagerModal?.(PRIVACY_MANAGER_AUSTRALIA);
            break;
    }
}
const CMP = {
    init,
    willShowPrivacyMessage,
    showPrivacyManager
};
export { CMP };
